import { render, staticRenderFns } from "./TreatmentList.vue?vue&type=template&id=61c5d4fd&scoped=true"
import script from "./TreatmentList.vue?vue&type=script&lang=js"
export * from "./TreatmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c5d4fd",
  null
  
)

export default component.exports